export default __webpack_public_path__ + "static/media/ki.427569b9.svg";